/* sn-accordion.js — shared accordion behaviour for all converted pages.
 *
 * SEO model: answers are rendered into the static HTML by the converter (it
 * force-opens the prototype accordions at SSR), so every Q&A is crawlable and
 * matches the FAQPage JSON-LD. This script PROGRESSIVELY ENHANCES that markup:
 * on load it collapses the answers and wires single-open toggling. With no JS,
 * all answers stay visible — still perfectly crawlable and usable.
 *
 * No per-page data and no dependencies. It finds accordion toggles structurally
 * (a flex space-between button whose last child is a "+"), groups them by their
 * containing accordion, and treats each toggle's next sibling as its answer.
 * Safe to load with `defer` on every page; a page with no accordion is a no-op.
 */
(function () {
  'use strict';

  function isToggle(btn) {
    if (!/justify-content:\s*space-between/.test(btn.getAttribute('style') || '')) return false;
    var last = btn.lastElementChild; // the "+" toggle (direct child, not a nested label span)
    return !!last && last.textContent.trim() === '+';
  }

  function initGroup(buttons) {
    var open = -1;
    function collapse(i) {
      var btn = buttons[i];
      var ans = btn.nextElementSibling;
      if (ans) ans.style.display = 'none';
      var plus = btn.lastElementChild;
      if (plus) plus.style.transform = 'none';
      btn.setAttribute('aria-expanded', 'false');
    }
    function expand(i) {
      var btn = buttons[i];
      var ans = btn.nextElementSibling;
      if (ans) ans.style.display = '';
      var plus = btn.lastElementChild;
      if (plus) { plus.style.transition = 'transform .2s ease'; plus.style.transform = 'rotate(45deg)'; }
      btn.setAttribute('aria-expanded', 'true');
    }
    buttons.forEach(function (btn, i) {
      collapse(i); // start collapsed (answers are present in the DOM from SSR)
      btn.addEventListener('click', function () {
        var wasOpen = open === i;
        if (open !== -1) collapse(open);
        if (wasOpen) { open = -1; return; }
        open = i;
        expand(i);
      });
    });
  }

  function init(root) {
    var all = Array.prototype.slice.call(root.querySelectorAll('button')).filter(isToggle);
    if (!all.length) return;
    // Group toggles by their containing accordion (button → row → accordion box).
    var groups = [];
    all.forEach(function (btn) {
      var box = btn.parentNode && btn.parentNode.parentNode;
      var g = null;
      for (var i = 0; i < groups.length; i++) { if (groups[i].box === box) { g = groups[i]; break; } }
      if (!g) { g = { box: box, items: [] }; groups.push(g); }
      g.items.push(btn);
    });
    groups.forEach(function (g) { initGroup(g.items); });
  }

  function boot() {
    var roots = document.querySelectorAll('[id^="sn-"]');
    if (roots.length) Array.prototype.forEach.call(roots, init);
    else init(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
